var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"firebase-help-message"},[_vm._v(" "+_vm._s(_vm.message)+" "),(_vm.showCreateButton)?_c('b-button',{attrs:{"size":"is-small","type":"is-danger","outlined":""},on:{"click":function($event){return _vm.create()}}},[_vm._v(" Создать ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }